import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { ICampaignLog } from "@/interfaces/campaign-logs.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class CampaignLogService {
  private baseUrl = "api/v1/campaignlog";

  async filter(
    filters: IFilter<ICampaignLog>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ICampaignLog>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter: filters,
    });

    return response;
  }
}

const campaignLogService = new CampaignLogService();
export default campaignLogService;
